<template>
        <div class="row"  id="forgotPassword">

            <div class="login_box">
                <div class="login_image_container">
                    <img src="../assets/images/clockit_login.png" class="login_image" />
                </div>

                <div class="login_form_container">
                    <form action="#" @submit.prevent="submitHandler">
                        <center>
                            <h4>{{ title }}</h4>
                        </center>
                        <br />
                        <p  v-if="!this.isSuccess">Please key in your email below.</p>
                        <div class="form-group"  v-if="!this.isSuccess">
                            <input type="email" class="form-control" placeholder="Email" v-model="email">
                        </div>

                        <div class="form-group">
                            <span v-if="this.errormsg" align="center"><p class="text-danger">{{ errormsg }}</p></span>
                            <span v-if="this.okmsg"><p class="text-primary">{{ okmsg }}</p></span>
                        </div>

                        <div class="form-group">
                            <center>
                                <button v-if="!this.isvalid" type="submit" class="btn btn-primary">SUBMIT</button>
                                <router-link :to="`/${$i18n.locale}/`"><button class="btn btn-danger">BACK TO LOGIN</button></router-link>
                            </center>
                        </div>

                    </form>
                </div>

            </div>
        </div>
</template>

<script>

import axios from 'axios'

export default {
    data () {
        return {
            email: '',
            baseURL:'',
            title: 'FORGOT PASSWORD',
            errormsg: null,
            okmsg: null,
            isvalid: false,
            isSuccess: false,
        }
    },

    methods: {
        submitHandler() {
            var vm = this

            var data = {
                email: this.email,
                baseURL: this.baseURL
            }

            axios.post(this.$store.getters.rootAPI + '/admin/forgotpassword', data)
            .then(function(response) {

                if (response.data.status == 'error' || response.data.status == 501) {
                    vm.errormsg = "Invalid user"
                } else {
                    vm.status = response.data.status
                    vm.errormsg = null
                    vm.okmsg = 'Email sent to ' + vm.email + '. Please check your email and follow the instruction to reset your password'
                    vm.isvalid = true;
                    vm.isSuccess = true;
                }

            })
            .catch(function (error) {
                console.log(error)
            });
        },

        getBaseURL(){
            var protocol = window.location.protocol;
            var hostname = window.location.hostname;
            var port = window.location.port;
            var rpathname = window.location.pathname;

            var cpathname = rpathname.substring(
                rpathname.indexOf("/"),
                rpathname.indexOf("/", rpathname.indexOf("/") + 1)
            );

            if (port) {
                port = ':' + port;
                this.baseURL = protocol + '//' + hostname + port + cpathname;
            } else {
                this.baseURL = protocol + '//' + hostname + cpathname;
            }

            //console.log(this.baseURL);
        }
    },

    mounted() {
        this.getBaseURL();
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ForgotPassword.vue